import config from "../../config/config";

const getToken = (): string | null => localStorage.getItem('jwt_token');

export const apiGet = async <T>(url: string): Promise<T> => {
  const response = await fetch(`${config.apiUrl}/api${url}`);

  if (!response.ok) {
    throw new Error(`API GET ${url} failed`);
  }

  return response.json() as Promise<T>;
};

export const apiPost = async <T>(url: string, body: unknown): Promise<T> => {
  const token = getToken();
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const response = await fetch(`${config.apiUrl}/api${url}`, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`API POST ${url} failed`);
  }

  return response.json() as Promise<T>;
};

export const apiPatch = async <T>(url: string, body: unknown): Promise<T> => {
  const token = getToken();
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const response = await fetch(`${config.apiUrl}/api${url}`, {
    method: "PATCH",
    headers,
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`API PATCH ${url} failed`);
  }

  return response.json() as Promise<T>;
};


/** Failed request with the HTTP status, for callers that react to specific codes. */
export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

/** Authorized request with an optional multipart body; throws ApiError with the backend's message. */
export const apiSend = async <T>(method: "GET" | "POST" | "DELETE", url: string, body?: FormData): Promise<T> => {
  const token = getToken();
  const response = await fetch(`${config.apiUrl}/api${url}`, {
    method,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body,
  });

  if (!response.ok) {
    const data = await response.json().catch(() => null);
    throw new ApiError(response.status, data?.error ?? `API ${method} ${url} failed`);
  }

  return response.json() as Promise<T>;
};
